import {Stack} from 'src/design/atoms/Stack';
import React from 'react';

import {BackBar} from 'src/app/layout/BackBar';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {PageHeader} from 'src/design/organisms/PageHeader';
import {SidebarLinkTestArea} from 'src/app/layout/Sidebar/SidebarLinksConfig';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {ProactFormEngineExample} from './components/ProactFormEngineExample';

export const EditTestFormPage: React.FC = () => {
  return (
    <ContentWrapper>
      <Stack gap="lg">
        <BackBar
          fallbackTo={PathUtility.AdminTestArea()}
          fallbackLabel="Back to Test Area"
          breadcrumbs={[
            {label: 'System', to: PathUtility.AdminSystem()},
            {label: 'Test Area', to: PathUtility.AdminTestArea()},
            {label: 'Edit Test Form'},
          ]}
        />
        <PageHeader>
          <PageHeader.Title
            icon={SidebarLinkTestArea.icon}
            subtitle="Proact Form Engine demonstration">
            Edit Test Form
          </PageHeader.Title>
        </PageHeader>
        <ProactFormEngineExample />
      </Stack>
    </ContentWrapper>
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.AdminEditTestForm(),
  element: <EditTestFormPage />,
  isPrivate: true,
  requireSuperAdmin: true,
});

export default EditTestFormPage;
